var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumbergold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_8665_1244)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8232 31.5H19.2969V19.1074L19.3408 17.0859L19.4141 14.8447C18.6621 15.5967 18.1396 16.0898 17.8467 16.3242L15.3857 18.3018L13.2031 15.5771L20.1025 10.084H23.8232V31.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8665_1244",
    x1: 7.79498,
    y1: -16.4705,
    x2: 52.1592,
    y2: 5.68635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.20179,
    stopColor: "#DD9318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492722,
    stopColor: "#FFCB3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.620192,
    stopColor: "#FFE09C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735577,
    stopColor: "#F8C035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E39C1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumbergold);
export default __webpack_public_path__ + "static/media/numbergold.b14348ae7aa7dae4c0cc4a66181cb0f5.svg";
export { ForwardRef as ReactComponent };